import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-cream text-stone-900 flex flex-col items-center justify-center px-4 text-center">
      <span className="w-16 h-16 rounded-lg bg-emerald-100 text-emerald-700 flex items-center justify-center">
        <i className="ri-question-line text-3xl" />
      </span>
      <h1 className="mt-6 font-heading text-2xl md:text-4xl font-bold text-stone-900">
        Page not found
      </h1>
      <p className="mt-3 text-sm md:text-base text-stone-600 max-w-md">
        The page you are looking for does not exist or may have moved.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-md bg-emerald-600 px-6 py-3 text-sm font-semibold text-white hover:bg-emerald-700 whitespace-nowrap cursor-pointer"
      >
        Back to Homepage
      </Link>
    </div>
  );
}